<template>
    <div class="d-flex justify-content-end mt-30">
        <a @click="download()"
            class="cursor-pointer d-inline-flex text-decoration-none lh-1 text-muted fw-medium gap-2 align-items-center">
            <template v-if="!loading">
                <i class="ph-duotone ph-download text-black fs-16"></i>
            </template>
            <template v-else>
                <SpinnerLoading class="mb-0 h-auto" :small="true"></SpinnerLoading>
            </template>
            {{ $t('cta.download_patient_data') }}
        </a>
        <!-- ERRORS -->
        <div class="form-messages mt-2 px-1" v-if="errors?.message ?? false">
            <p v-for="error in errors.message" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                error }}</p>
        </div>
    </div>
    <AlertModal id="alertModal" :title="$t('cta.download_patient_data')" :dismissible="false"
        :message="message ?? $t('feature.auth.$download_patient_data.success_message')" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AlertModal from '@/components/Widgets/AlertModal.vue';
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import API from '@/services/api/api.service';
import { Modal } from 'bootstrap';

export default defineComponent({
    name: "DownloadPatientData",
    props: {
        patient_id: {
            type: String,
            required: true
        }
    },
    components: {
        AlertModal,
        SpinnerLoading
    },
    data: function () {
        return {
            password: undefined as any,
            message: undefined as any,
            errors: undefined as any,
            alertModal: null as Modal | null,
            loading: false,
        }
    },
    mounted() {
        console.log('DOWNLOAD')
        this.alertModal = new Modal('#alertModal', {});
    },
    methods: {
        buildMessage(password: string, response?: string ): string {
            let message = response ?? this.$t('feature.auth.$download_patient_data.success_message');
            message = message + '<br>' + this.$t('form.password.label') + ': <strong>' + password + '</strong>';

            return message;
        },
        download() {
            this.errors = undefined;
            this.message = undefined;
            this.password = undefined;
            this.loading = true;
            API.downloadPatientData({ patient_id: this.patient_id }).then((response) => {
                this.loading = false;
                if (response.data.success === true) {
                    this.alertModal?.show();
                    this.message = this.buildMessage(response.data.password, response.data.message);
                } else {
                    this.errors = response.data?.message;
                    this.message = response.data?.message;
                }
            }).catch((error) => {
                this.password = undefined;
                this.loading = false;
                this.errors = error.response?.data?.message;
                this.message = error.response?.data?.message;
            })
        }
    }
});
</script>